import {
  CreateUserBankAccountRequestDto,
  CreateUserBankAccountResponseDto,
  ReadUserBankAccountsRequestDto,
  ReadUserBankAccountsResponseDto,
  UpdateBankAccountRequestDto,
  UpdateUserBankAccountResponseDto,
  DeleteUserBankAccountRequestDto,
  DeleteUserBankAccountResponseDto,
  ReadUserSfBankAccountRequestDto,
  ReadUserSfBankAccountResponseDto,
  IUserBankAccount,
} from '@sparling/financial-common'
import axios, { AxiosRequestConfig } from 'axios'
import isNil from 'lodash/isNil'

export const createUserBankAccount = async (
  { token, ...params }: CreateUserBankAccountRequestDto & { token: string },
  options: AxiosRequestConfig = {},
): Promise<CreateUserBankAccountResponseDto> => {
  const response = await axios.post<CreateUserBankAccountResponseDto>(
    `${process.env.REACT_APP_REST_API_URL}/user/bank-accounts`,
    Object.fromEntries(Object.entries(params).filter(([, value]) => !isNil(value) && value !== '')),
    {
      ...options,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
        ...options.headers,
      },
    },
  )
  return response.data
}

export const fetchUserBankAccounts = async (
  { token, ...params }: ReadUserBankAccountsRequestDto & { token: string },
  options: AxiosRequestConfig = {},
): Promise<ReadUserBankAccountsResponseDto> => {
  const response = await axios.get<ReadUserBankAccountsResponseDto>(
    `${process.env.REACT_APP_REST_API_URL}/user/bank-accounts`,
    {
      ...options,
      params: Object.fromEntries(Object.entries(params).filter(([, value]) => !isNil(value) && value !== '')),
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
        ...options.headers,
      },
    },
  )
  return response.data
}

export const fetchUserBankAccountList = async (
  { token }: { token: string },
  options: AxiosRequestConfig = {},
): Promise<IUserBankAccount[]> => {
  const response = await axios.get<IUserBankAccount[]>(
    `${process.env.REACT_APP_REST_API_URL}/user/bank-accounts/list`,
    {
      ...options,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
        ...options.headers,
      },
    },
  )
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  return response.data.data
}

export const updateUserBankAccount = async (
  { token, id, ...params }: UpdateBankAccountRequestDto & { id: number; token: string },
  options: AxiosRequestConfig = {},
): Promise<UpdateUserBankAccountResponseDto> => {
  const response = await axios.patch<UpdateUserBankAccountResponseDto>(
    `${process.env.REACT_APP_REST_API_URL}/user/bank-accounts/${id}`,
    params,
    {
      ...options,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
        ...options.headers,
      },
    },
  )
  return response.data
}

export const deleteUserBankAccount = async (
  { token, id }: DeleteUserBankAccountRequestDto & { id: number; token: string },
  options: AxiosRequestConfig = {},
): Promise<DeleteUserBankAccountResponseDto> => {
  const response = await axios.delete<DeleteUserBankAccountResponseDto>(
    `${process.env.REACT_APP_REST_API_URL}/user/bank-accounts/${id}`,
    {
      ...options,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
        ...options.headers,
      },
    },
  )
  return response.data
}

export const fetchUserSfBankAccounts = async (
  { token, ...params }: Omit<ReadUserSfBankAccountRequestDto, 'idSf'> & { token: string },
  options: AxiosRequestConfig = {},
): Promise<{
  data: ReadUserSfBankAccountResponseDto
}> => {
  const response = await axios.get<{
    data: ReadUserSfBankAccountResponseDto
  }>(`${process.env.REACT_APP_REST_API_URL}/user/sf-bank-accounts`, {
    ...options,
    params: Object.fromEntries(Object.entries(params).filter(([, value]) => !isNil(value))),
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })
  return response.data
}
